import { render, staticRenderFns } from "./EducationalStages.vue?vue&type=template&id=20e2a504&"
import script from "./EducationalStages.vue?vue&type=script&lang=js&"
export * from "./EducationalStages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports